self["MonacoEnvironment"] = (function (paths) {
      function stripTrailingSlash(str) {
        return str.replace(/\/$/, '');
      }
      return {
        getWorkerUrl: function (moduleId, label) {
          var pathPrefix = typeof __webpack_public_path__ === 'string' ? __webpack_public_path__ : "./";
          var result = (pathPrefix ? stripTrailingSlash(pathPrefix) + '/' : '') + paths[label];
          if (/^((http:)|(https:)|(file:)|(\/\/))/.test(result)) {
            var currentUrl = String(window.location);
            var currentOrigin = currentUrl.substr(0, currentUrl.length - window.location.hash.length - window.location.search.length - window.location.pathname.length);
            if (result.substring(0, currentOrigin.length) !== currentOrigin) {
              var js = '/*' + label + '*/importScripts("' + result + '");';
              var blob = new Blob([js], { type: 'application/javascript' });
              return URL.createObjectURL(blob);
            }
          }
          return result;
        }
      };
    })({
  "editorWorkerService": "editor.worker.js"
});
require("./contrib/bracketMatching/bracketMatching.js");
require("./contrib/caretOperations/caretOperations.js");
require("./contrib/clipboard/clipboard.js");
require("./contrib/contextmenu/contextmenu.js");
require("./browser/controller/coreCommands.js");
require("./contrib/cursorUndo/cursorUndo.js");
require("./contrib/find/findController.js");
require("./contrib/folding/folding.js");
require("./contrib/fontZoom/fontZoom.js");
require("./standalone/browser/quickAccess/standaloneGotoLineQuickAccess.js");
require("./standalone/browser/iPadShowKeyboard/iPadShowKeyboard.js");
require("./contrib/inPlaceReplace/inPlaceReplace.js");
require("./contrib/indentation/indentation.js");
require("./contrib/linesOperations/linesOperations.js");
require("./contrib/links/links.js");
require("./contrib/multicursor/multicursor.js");
require("./contrib/smartSelect/smartSelect.js");
require("./contrib/unusualLineTerminators/unusualLineTerminators.js");
module.exports = require("!!./editor.main.js");
require("../basic-languages/yaml/yaml.contribution.js");
require("../basic-languages/cpp/cpp.contribution.js");
require("../basic-languages/java/java.contribution.js");
require("../basic-languages/kotlin/kotlin.contribution.js");
require("../basic-languages/pascal/pascal.contribution.js");
require("../basic-languages/python/python.contribution.js");
require("../basic-languages/rust/rust.contribution.js");
require("../basic-languages/go/go.contribution.js");
require("../basic-languages/csharp/csharp.contribution.js");
require("../basic-languages/fsharp/fsharp.contribution.js");